// material ui
import { Card, CardContent, CardHeader } from '@mui/material';

// api
// * RTK Query
import { useUnitsGetCollectionAsyncByqueryOptionsQuery } from '@/api/generated/recalc/endpoints/v1/units';

// relative
// * Hooks
import useUnitData from '../../hooks/useUnitData';
// * Components
import UnitAlarmChart from '../highcharts/UnitAlarmChart';

import { DateTime } from 'luxon';

// * Utils
function formatDanishDate(timestamp) {
  if (!timestamp) return '';
  return DateTime.fromISO(timestamp, { zone: 'utc' })
    .setLocale('da')
    .toFormat('dd. MMM yyyy HH:mm:ss');
}

const HeatingSystem = ({ alarm }) => {
  const associatedUnits = alarm?.Associations?.Units || [];

  const { data: units } = useUnitsGetCollectionAsyncByqueryOptionsQuery(
    { 'Account.AccountId': `eq(${alarm?.AccountId})` },
    { skip: !alarm?.AccountId || associatedUnits.length === 0 },
  );

  const unitMatches = units
    ? units.filter((unit) => associatedUnits.some((id) => id === unit.UnitId))
    : [];

  const { chartSeries, isLoading } = useUnitData({
    accountId: alarm?.AccountId,
    selectedUnits: unitMatches,
    dateRange: {
      from: alarm?.DataFrom,
      to: alarm?.DataTo,
    },
    aggregateOverride: 'Minutes5',
  });

  console.log('Rendering HeatingSystem with alarm:', alarm);
  return (
    <Card>
      <CardHeader
        title={`Heating System Data`}
        subheader={`${formatDanishDate(alarm?.DataFrom)} - ${formatDanishDate(alarm?.DataTo)}`}
        slotProps={{
          title: { variant: 'h6' }
        }}
      />
      <CardContent style={{ marginTop: -32 }}>
        <UnitAlarmChart
          unitData={chartSeries}
          isLoading={isLoading}
          alarm={alarm}
        />
      </CardContent>
    </Card>
  );
};

export default HeatingSystem;

